// extracted by mini-css-extract-plugin
export var currencyInput = "_nv-1";
export var currencySymbol = "_nv-0";